import React from 'react';
import FilePreviewRenderer from '../../common/functions/FilePreviewRenderer';

const ImagePreview = ({ imageData, selectedFile }) => {
  if (!imageData?.detail?.response_image || !selectedFile?.type) {
    return <p>Invalid or missing image data.</p>;
  }

  try {
    const base64 = imageData.detail.response_image;
    const byteString = atob(base64);
    const arrayBuffer = new Uint8Array(byteString.length);

    for (let i = 0; i < byteString.length; i++) {
      arrayBuffer[i] = byteString.charCodeAt(i);
    }

    const fileBlob = new Blob([arrayBuffer], { type: selectedFile.type });

    return (
      <div className="d-flex flex-column h-100">
        <div className="align-items-center d-flex h-100 justify-content-center">
          <FilePreviewRenderer
            file={fileBlob}
            originalFileType={selectedFile.type}
          />
        </div>
      </div>
    );
  } catch (err) {
    console.error('Error converting base64 to Blob:', err);
    return (
      <div className="d-flex flex-column h-100">
        <div className="align-items-center d-flex h-100 justify-content-center">
          <p>Failed to render image.</p>
        </div>
      </div>
    );
  }
};

export default ImagePreview;
